export default __webpack_public_path__ + "static/media/frenchfries.cf6c53a6.jpg";